import accordionAria from "./accordion-aria"


class NativeReviews extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click',() => {
      this.jumpToTrustpilot();
    })
  }

  jumpToTrustpilot() {
    document.querySelector('.accordion.accordion--product.accordion--product-reviews').scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (document.querySelector(".accordion--product-reviews") !== null) {
      accordionAria(".accordion--product-reviews", {}).init();
      accordionAria(".accordion--product-reviews").showInitialItem();
    }
  }

}

customElements.define("native-reviews", NativeReviews);